const COLORS = [
	'#329ae4', // blue
	'#07ee8f', // green
	'#eeba07', // orange
	'#ee0784', // pink-red
	'#ebee07', // yellow
	'#07e6ee' // cyan
]

export class ColorWheel {

	constructor() {
		this.colors = COLORS.slice();
		this.index = 0;
	}
	
	get next() {
		if( this.index > this.colors.length - 1 ) {
			this.index = 0;
		}
		
		const color = this.colors[this.index];
		this.index++;
		
		return color;
	}
}